<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="layout-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">テーマ設定</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body modal-layout">
                    <div class="form-group">
                        <label>文字サイズ</label>
                        <div class="btn-group btn-block">
                            <button type="button" class="btn btn-outline-secondary btn-sm font-small" :class="{active: layout.font_size == 1}" @click="layout.font_size = 1">小</button>
                            <button type="button" class="btn btn-outline-secondary btn-sm font-medium" :class="{active: layout.font_size == 2}" @click="layout.font_size = 2">中</button>
                            <button type="button" class="btn btn-outline-secondary btn-sm font-large" :class="{active: layout.font_size == 3}" @click="layout.font_size = 3">大</button>
                            <button type="button" class="btn btn-outline-secondary btn-sm font-extralarge" :class="{active: layout.font_size == 4}" @click="layout.font_size = 4">特大</button>
                            <button type="button" class="btn btn-outline-secondary btn-sm font-huge" :class="{active: layout.font_size == 5}" @click="layout.font_size = 5">最大</button>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>フラット背景色</label>
                        <div class="btn-group btn-block">
                            <button type="button" class="btn btn-outline-secondary font-white" :class="{checked: layout.background_color == 'white'}" @click="layout.background_color = 'white'">
                                <i class="fas fa-check-circle" v-if="layout.background_color == 'white'"></i>
                                白
                            </button>
                            <button type="button" class="btn btn-outline-secondary font-black" :class="{checked: layout.background_color == 'black'}" @click="layout.background_color = 'black'">
                                <i class="fas fa-check-circle" v-if="layout.background_color == 'black'"></i>
                                黒
                            </button>
                            <button type="button" class="btn btn-outline-secondary font-zouge" :class="{checked: layout.background_color == 'zouge'}" @click="layout.background_color = 'zouge'">
                                <i class="fas fa-check-circle" v-if="layout.background_color == 'zouge'"></i>
                                象牙
                            </button>
                            <button type="button" class="btn btn-outline-secondary font-sakura" :class="{checked: layout.background_color == 'sakura'}" @click="layout.background_color = 'sakura'">
                                <i class="fas fa-check-circle" v-if="layout.background_color == 'sakura'"></i>
                                桜
                            </button>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>グラデーション背景色</label>
                        <div class="btn-group btn-block">
                            <button type="button" class="btn btn-outline-secondary font-dreamy" :class="{checked: layout.background_color == 'dreamy'}" @click="layout.background_color = 'dreamy'">
                                <i class="fas fa-check-circle" v-if="layout.background_color == 'dreamy'"></i>
                                ゆめいろ
                            </button>
                            <button type="button" class="btn btn-outline-secondary font-forest" :class="{checked: layout.background_color == 'forest'}" @click="layout.background_color = 'forest'">
                                <i class="fas fa-check-circle" v-if="layout.background_color == 'forest'"></i>
                                森林
                            </button>
                            <button type="button" class="btn btn-outline-secondary font-cosmo" :class="{checked: layout.background_color == 'cosmo'}" @click="layout.background_color = 'cosmo'">
                                <i class="fas fa-check-circle" v-if="layout.background_color == 'cosmo'"></i>
                                ラベンダー
                            </button>
                            <button type="button" class="btn btn-outline-secondary font-metal" :class="{checked: layout.background_color == 'metal'}" @click="layout.background_color = 'metal'">
                                <i class="fas fa-check-circle" v-if="layout.background_color == 'metal'"></i>
                                金属
                            </button>
                        </div>
                        <div class="btn-group btn-block">
                            <button type="button" class="btn btn-outline-secondary font-doom" :class="{checked: layout.background_color == 'doom'}" @click="layout.background_color = 'doom'">
                                <i class="fas fa-check-circle" v-if="layout.background_color == 'doom'"></i>
                                闇夜
                            </button>
                            <button type="button" class="btn btn-outline-secondary font-rome" :class="{checked: layout.background_color == 'rome'}" @click="layout.background_color = 'rome'">
                                <i class="fas fa-check-circle" v-if="layout.background_color == 'rome'"></i>
                                ワイン
                            </button>
                            <button type="button" class="btn btn-outline-secondary font-jupiter" :class="{checked: layout.background_color == 'jupiter'}" @click="layout.background_color = 'jupiter'">
                                <i class="fas fa-check-circle" v-if="layout.background_color == 'jupiter'"></i>
                                木星
                            </button>
                            <button type="button" class="btn btn-outline-secondary font-space" :class="{checked: layout.background_color == 'space'}" @click="layout.background_color = 'space'">
                                <i class="fas fa-check-circle" v-if="layout.background_color == 'space'"></i>
                                宇宙
                            </button>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>フォント</label>
                        <div class="btn-group btn-block">
                            <button type="button" class="btn btn-outline-secondary btn-sm  mincho" :class="{active: layout.font == 'mincho'}" @click="layout.font = 'mincho'">明朝</button>
                            <button type="button" class="btn btn-outline-secondary btn-sm " :class="{active: layout.font == 'gothic'}" @click="layout.font = 'gothic'">ゴシック</button>
                            <button type="button" class="btn btn-outline-secondary btn-sm  ud" :class="{active: layout.font == 'ud'}" @click="layout.font = 'ud'">UD明朝</button>
                            <button type="button" class="btn btn-outline-secondary btn-sm  kaisei" :class="{active: layout.font == 'kaisei'}" @click="layout.font = 'kaisei'">解星</button>
                        </div>
                    </div>
                    <div class="form-group" v-if="isFull">
                        <label>組み方向</label>
                        <div class="btn-group btn-block">
                            <button type="button" class="btn btn-outline-secondary" :class="{active: layout.is_horizontal == 1}" @click="layout.is_horizontal = 1">
                                <i class="fas fa-align-left"></i>
                                横書き
                            </button>
                            <button type="button" class="btn btn-outline-secondary" :class="{active: layout.is_horizontal == 0}" @click="layout.is_horizontal = 0">
                                <i class="fas fa-align-left fa-rotate-90"></i>
                                縦書き
                            </button>
                        </div>
                    </div>
                    <div class="form-group" v-if="isFull">
                        <label>ノベルゲーム風文字出力</label>
                        <div class="btn-group btn-block">
                            <button type="button" class="btn btn-outline-secondary btn-sm" :class="{active: layout.output_style == 0}" @click="layout.output_style = 0">全文</button>
                            <button type="button" class="btn btn-outline-secondary btn-sm" :class="{active: layout.output_style == 1}" @click="layout.output_style = 1">ゆっくり</button>
                            <button type="button" class="btn btn-outline-secondary btn-sm" :class="{active: layout.output_style == 2}" @click="layout.output_style = 2">通常</button>
                            <button type="button" class="btn btn-outline-secondary btn-sm" :class="{active: layout.output_style == 3}" @click="layout.output_style = 3">高速</button>
                        </div>
                        <div class="text-muted xsmall">
                            「全文」はすべての文章を表示します。
                            「ゆっくり」「通常」「高速」は文章を一文字ずつ表示します。
                            「全文」以外のときは、本文をすべて表示することで、次のエピソードへのページリンクが表示されます。
                        </div>
                    </div>
                    <div class="form-group" v-if="isFull">
                        <label>カーソル音</label>
                        <div class="btn-group btn-block">
                            <button type="button" class="btn btn-outline-secondary btn-sm" :class="{active: layout.sound_effect == 0}" @click="layout.sound_effect = 0">無し</button>
                            <button type="button" class="btn btn-outline-secondary btn-sm" :class="{active: layout.sound_effect == 1}" @click="layout.sound_effect = 1">ｶｶｶｶ…</button>
                            <button type="button" class="btn btn-outline-secondary btn-sm" :class="{active: layout.sound_effect == 2}" @click="layout.sound_effect = 2">ﾄﾞﾙﾙﾙ…</button>
                            <button type="button" class="btn btn-outline-secondary btn-sm" :class="{active: layout.sound_effect == 3}" @click="layout.sound_effect = 3">ﾄﾄﾄﾄ…</button>
                        </div>
                        <div class="text-muted xsmall">
                            文字出力時のカーソル音を指定できます。
                            カーソル音が有効な場合、本文は自動出力しません。タップ/クリックで出力を開始してください。
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click="close()">完了</button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
#layout-modal {
    .modal-dialog {
        z-index: 9999;
        .modal-layout {
            label {
                font-size: .8rem;
                margin-bottom: .3rem;
            }
            .xsmall {
                font-size: .65rem;
            }
        }
    }
}
.font-small {
    font-size: .7rem;
}
.font-medium {
    font-size: 1.0rem;
}
.font-large {
    font-size: 1.1rem;
}
.font-extralarge {
    font-size: 1.2rem;
}
.font-huge {
    font-size: 1.3rem;
}
.font-white {
    background-color: white;
    &:hover, &.checked {
        background-color: #f3f4f5;
        color: #468;
    }
}
.font-black {
    background-color: #333;
    color: snow;
    &:hover, &.checked {
        background-color: #000;
        color: white;
    }
}
.font-zouge {
    background-color: #f8f4e6;
    &:hover, &.checked {
        background-color: #e9e4d4;
        color: #468;
    }
}
.font-sakura {
    background-color: #fef4f4;
    &:hover, &.checked {
        background-color: #fdeff2;
        color: #468;
    }
}
.font-dreamy {
    background: linear-gradient(70deg, #d8eaff, #f3e1ff, #ffceda);
    &:hover, &.checked {
        background: linear-gradient(70deg, #d8eaff88, #f3e1ff88, #ffceda88);
        color: #468;
    }
}
.font-forest {
    background: linear-gradient(70deg, #d8dab8, #d2dacd, #c5d5ce);
    &:hover, &.checked {
        background: linear-gradient(70deg, #d8dab888, #d2dacd88, #c5d5ce88);
        color: #468;
    }
}
.font-cosmo {
    background: linear-gradient(70deg, #9db9d2, #b9bfe0, #bcb3d6);
    &:hover, &.checked {
        background: linear-gradient(70deg, #9db9d288, #b9bfe088, #bcb3d688);
        color: #468;
    }
}
.font-metal {
    background: linear-gradient(70deg, #f5f7f8, #d4d5db, #aa9fa7);
    &:hover, &.checked {
        background: linear-gradient(70deg, #f5f7f888, #d4d5db88, #aa9fa788);
        color: snow
    }
}
.font-doom {
    background: linear-gradient(70deg, #243a49, #2d2451);
    color: snow;
    &:hover, &.checked {
        background: linear-gradient(70deg, #243a4988, #2d245188);
        color: white;
    }
}
.font-rome {
    background: linear-gradient(70deg, #720101, #010006);
    color: snow;
    &:hover, &.checked {
        background: linear-gradient(70deg, #72010188, #01000688);
        color: white;
    }
}
.font-jupiter {
    background: linear-gradient(70deg, #482623, #412a14, #35390b);
    color: snow;
    &:hover, &.checked {
        background: linear-gradient(70deg, #48262388, #412a1488, #35390b88);
        color: white;
    }
}
.font-space {
    background: linear-gradient(70deg, #030210, #10333c);
    color: snow;
    &:hover, &.checked {
        background: linear-gradient(70deg, #03021088, #10333c88);
        color: white;
    }
}
</style>

<script>
export default {
    props: {
        isFull: {
            default: true,
        }
    },
    data() {
        return {
            layout: {}
        }
    },
    methods: {
        init() {
            this.layout = {
                font_size: this.$store.state.font_size,
                background_color: this.$store.state.background_color,
                font: this.$store.state.font,
                is_horizontal: this.$store.state.is_horizontal,
                output_style: this.$store.state.output_style || 0,
                sound_effect: this.$store.state.sound_effect || 0,
            };
        },
        close() {
            this.save();
            $("#layout-modal").modal("hide");
        },
        save() {
            axios.post("/layout/save", this.layout).catch(err => {
                alert.err(err.response);
            });
            this.$store.commit("setLayout", this.layout);
            this.$emit("saved");
        }
    },
    mounted() {
        $("#layout-modal").on("show.bs.modal", (e) => {
            this.init();
        });
        $("#layout-modal").on("hide.bs.modal", (e) => {
            this.save();
        });
    }
}
</script>